<div *ngIf="availableMetrics" class="vertical-stack">
  <mat-form-field appearance="outline" class="compact-form-field data-type-dropdown">
    <mat-select [placeholder]="'Select DataType'" [(ngModel)]="type" name="dataType" (selectionChange)="onDataTypeChange(type)">
      <mat-option *ngFor="let option of dataTypeOptions" [value]="option" >
        {{ option }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Dynamic input area -->
  <ng-container [ngSwitch]="type">

    <!-- Metric Input -->
    <mat-form-field *ngSwitchCase="'metric'" appearance="outline" class="compact-form-field">
      <input matInput [placeholder]="'Select Metric'" [value]="value?.metricName" [matAutocomplete]="auto" (input)="onValueChange($event.target)">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let metric of availableMetrics" [value]="metric" (onSelectionChange)="onValueChange(metric)">
          {{ metric.metricName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Text Input -->
    <mat-form-field *ngSwitchCase="'text'" appearance="outline" class="compact-form-field">
      <!-- <mat-label>Enter Text</mat-label> -->
      <input matInput [placeholder]="'Input Text'" [ngModel]="value" (ngModelChange)="onValueChange($event)" placeholder="Enter text">
    </mat-form-field>

  </ng-container>
</div>
